export function renderItem (item) {
    return `<div>
        <strong> ${item.qtd} x _${item.nome}</strong>_ 
        (R$ ${item.preco}) 
        <span class='preco'>R$ ${parseFloat(item.preco * item.qtd).toFixed(2)}</span>
        <div>
    `
}